var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262625",
    fillRule: "evenodd",
    d: "M6.576 12c-.184 0-.36-.076-.486-.21L2.848 8.337c-.253-.268-.239-.69.03-.942.268-.252.69-.238.941.03l2.75 2.927 5.606-6.135c.249-.272.67-.29.942-.042.272.248.29.67.042.941l-6.091 6.667c-.125.137-.302.216-.487.217h-.005z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_check.277ee70f.svg";
export { ForwardRef as ReactComponent };